import React from 'react'
import { Modal } from 'react-bootstrap'
import './CustomModal.scss'
import redCross from "../../assets/images/CommonComponent/redCross.svg"
import greenCheck from "../../assets/images/CommonComponent/GreenCheck.svg"
import { CircularProgress } from '@mui/material'

function CustomModal({show, setShow, onClickNo, onClickYes, title="Are you sure?", content="", loading=false }) {
  return (
    <div>
        <Modal centered className="custom-modal br-8" show={show} onHide={() => { setShow(false) }}>
                <Modal.Header className='w-100'>
                    <div className="modalText-guest text-center w-100 pb-4">{title}</div>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc-guest">
                        {content}
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" disabled={loading} className="btn btn-success greenButton mr-3" onClick={onClickYes}>
                        {
                            loading ?
                            <CircularProgress
                                size={25}
                                sx={{color: '#31C52B'}}
                            />
                            :
                            <>
                                <img className="mainIcon mr-2 " src={greenCheck} alt="" width="22px" height="22px" /> Yes
                            </>
                        }
                    </button>
                    <button type="button" className="btn btn-danger redButton " onClick={onClickNo}>
                        <img className="mainIcon mr-2 " src={redCross} alt="" width="16px" height="16px" /> No
                    </button>
                </Modal.Footer>
            </Modal>
    </div>
  )
}

export default CustomModal